import React from 'react';

import Navbar from '../../components/navbar'
import Footer from '../../components/footer'

import AccordionBase from '../../components/accordion';
import Accordion from 'react-bootstrap/Accordion';

import FormationText from '../../components/formation-text';
import FooterFormation from '../../components/footer-formation';

import '../formations-page.css'
import HelmetWidget from '../../components/helmet';

const FormationCoordonateurSPS = () => {
	// Ajouter numéro de téléphone
	return (
		<div className="formations-container">
			<HelmetWidget
				pageTitle="Formation Coordonnateur SPS"
				description="La formation CSPS vise à doter les participants des connaissances et compétences nécessaires pour exercer la fonction de Coordonnateur en matière de Sécurité et de Protection de la Santé, avec de niveau 1 à 3 et nécessitant une réactualisation tous les 5 ans."
				path="formations/formation-coordonateur-sps"
			></HelmetWidget>
			<Navbar></Navbar>
			<div className="home-hero titre-formation">
				<h1 className="title-text">FORMATION COORDONNATEUR SPS</h1>
			</div>
			<div className="content-div">
				<div className="accordions-div">
					<Accordion defaultActiveKey="100">
						<AccordionBase
							numberKey="0"
							titre="Formation spécifique Coordonnateur SPS - niveau 1, 2 et 3"
							nomFormation="CSPS"
							lienCPF="https://www.moncompteformation.gouv.fr/espace-prive/html/#/formation/recherche/52447547200048_SPS-INITIALE/52447547200048_CSPS-INITIALE-NV1CR"
							programmeLink="Programme CSPS 1CR 24J.pdf"
							duree="entre 13 jours / 91 heures et 24 jours / 168 heures (selon niveau et modules)"
							prix="de 2 590€ HT à 3 990€ HT (selon niveau et modules)"
							tauxReussite="100"
							recyclage="Une formation d'actualisation est à effectuer tous les 5 ans pour maintenir la validité de la formation."
							objectif={[
								"Mettre en œuvre le dispositif de coordination SPS sur les opérations de niveau 1, 2 ou 3, phase conception et/ou réalisation",
								"Exercer la mission de Coordonnateur de Sécurité et de Protection de la Santé en ayant obtenu l’attestation de compétence obligatoire (conception et/ou réalisation)."
							]}
							participants={[
								"Toute personne physique justifiant d’une expérience professionnelle d’une durée minimale de 3 à 5 ans (selon niveau) :",
								"En architecture, ingénierie ou maîtrise d’œuvre, pour la phase de conception, d’étude et d’élaboration du projet de l’ouvrage ;",
								"En matière de contrôle des travaux, d’ordonnancement, de pilotage et de conduite des travaux ou de maîtrise de chantier, ou en tant que Coordonnateur ou Agent en matière de sécurité, pour la phase de réalisation de l’ouvrage."
							]}
							preRequis={["Justifier d’une expérience professionnelle d’une durée minimale de 3 à 5 ans (selon niveau) : en architecture, ingénierie ou maîtrise d’œuvre, pour le suivi de la phase de conception, d’étude et d’élaboration du projet de l’ouvrage ; et/ou en matière de contrôle des travaux, d’ordonnancement, de pilotage et de conduite des travaux ou de maîtrise de chantier, ou en tant que Coordonnateur ou Agent en matière de sécurité, pour la phase de réalisation de l’ouvrage."]}
							numeroRS={"RS5774"}
							eligibleCPF={true}
							dateDebutParcours={"01/01/2022"}
							dateEcheanceEnregistrement={"31/12/2026"}
							intituleRS={"Coordonnateur en matière de sécurité et de protection de la santé"}
							lienFranceCompetences={"https://www.francecompetences.fr/recherche/rs/5774"}
							certificateur={"MINISTERE DU TRAVAIL DU PLEIN EMPLOI ET DE L' INSERTION - 11000007200014"}
							arrete={"application de l’article L. 4532-2 du code du travail, articles R. 4532-11 à 37 du code du travail, complétés par l’arrêté du 26 décembre 2012"}
						>
							<div className="cert-info">
								<p><strong>Modules suivis par niveau :</strong></p>
								<p><u>Niveau 3</u> = Tronc commun</p>
								<p><u>Niveau 2 réalisation</u> = Tronc commun + réalisation</p>
								<p><u>Niveau 2 conception/réalisation</u> = Tronc commun + réalisation + conception</p>
								<p><u>Niveau 1 réalisation</u> = Tronc commun + réalisation + CISSCT</p>
								<p><u>Niveau 1 conception/réalisation</u> = Tronc commun + réalisation + conception + CISSCT</p>
								<p>Durée des modules : Tronc commun = 12 jours, Réalisation = 4 jours, Conception = 4 jours, CISSCT = 2 jours</p>
								<p><em>*Passage devant le jury d'examen commun à tous les niveaux</em></p>
							</div>
						</AccordionBase>
						<AccordionBase
							numberKey="1"
							titre="Actualisation CSPS"
							nomFormation="CSPS"
							lienCPF="https://www.moncompteformation.gouv.fr/espace-prive/html/#/formation/recherche/52447547200048_SPS-INITIALE/52447547200048_Actualisation-CSPS"
							programmeLink="Programme CSPS Actualisation.pdf"
							duree="5 jours / 35 heures"
							prix="1 490€ HT"
							tauxReussite="100"
							objectif={[
								"Poursuivre vos missions de coordonnateur SPS suite à l’actualisation de vos compétences",
								"Obtenir le renouvellement de vos attestations de compétences pour une durée de 5 ans et de conseiller la maîtrise d’ouvrage sur la mise en œuvre des nouvelles dispositions"
							]}
							preRequis={[
								"Être titulaire d’une attestation de compétence de coordonnateur SPS niveau 1, 2 ou 3 en cours de validité",
							]}
							programme={[
								"Réactualiser les connaissances nécessaires à l’exercice de la fonction de CSPS",
								"Obtenir l’attestation de compétences CSPS réactualisée niveau 1 (conception et/ou réalisation)",
								"Alternance d’exposés théoriques et d’études de cas :",
								"L’expérience des stagiaires",
								"L’évolution réglementaire",
								"L’évolution de la phase de conception",
								"Les fondamentaux et les écrits du CSPS",
								"Les risques spécifiques (chimiques, toxiques, plomb, amiante, légionellose)",
								"L’analyse des risques chantier"
							]}
							numeroRS={"RS5774"}
							eligibleCPF={true}
							dateDebutParcours={"01/01/2022"}
							dateEcheanceEnregistrement={"31/12/2026"}
							intituleRS={"Coordonnateur en matière de sécurité et de protection de la santé"}
							lienFranceCompetences={"https://www.francecompetences.fr/recherche/rs/5774"}
							certificateur={"MINISTERE DU TRAVAIL DU PLEIN EMPLOI ET DE L' INSERTION - 11000007200014"}
							arrete={"application de l’article L. 4532-2 du code du travail, articles R. 4532-11 à 37 du code du travail, complétés par l’arrêté du 26 décembre 2012"}
						></AccordionBase>
					</Accordion>
					<FooterFormation 
						nomFormation="CSPS"
						downloadLink={"CSPS.pdf"}
					></FooterFormation>
				</div>
				<FormationText
					objectif="La formation CSPS vise à doter les participants des connaissances et compétences nécessaires pour exercer la fonction de Coordonnateur en matière de Sécurité et de Protection de la Santé, avec des niveaux allant de 1 à 3, couvrant les phases de conception et/ou réalisation, et nécessitant une réactualisation tous les 5 ans."
					downloadLink="CSPS.pdf"
					tauxSatisfaction="91"
				></FormationText>
			</div>
			<Footer></Footer>
		</div>
	)
}

export default FormationCoordonateurSPS
